module.exports = __webpack_public_path__ + "static/media/Intersection 31.20ef5df2.png";